import { PLAN_KEY } from '../../../../modules/plan/model'
import updatePlanAction from '../update'
import PLANS_ACTION from '../../constants/action'
import { createISOStrDateUtil } from 'packages/src'

function updateStartedAtPlanAction () {
  return updatePlanAction({
    type: PLANS_ACTION.UPDATE_STARTED_AT,
    payload: {
      key: PLAN_KEY.STARTED_AT,
      value: createISOStrDateUtil()
    }
  })
}

export default updateStartedAtPlanAction
